import { useNavigate } from "react-router-dom";
import { coachPaths } from "../routes/coach";
import { findAJobPaths } from "../routes/find-a-job";
import { hireTalentPaths } from "../routes/hire-talent";
import { useEffect, useState } from "react";
import CoachSignUp from "../components/Modals/SignupSteps";
import CoachSignUpStep1Modal from "../components/Modals/SignupSteps/CoachSignUpStep1Modal";
import CoachSignUpStep2Modal from "../components/Modals/SignupSteps/CoachSignUpStep2Modal";
import CoachSignUpStep3Modal from "../components/Modals/SignupSteps/CoachSignUpStep3Modal";
import CoachLogin from "../components/Modals/CoachLoginModal";
import CoachForgotPassword from "../components/Modals/ForgotPassword";
import Loader from "../components/loader";
import { useDispatch, useSelector } from "react-redux";
import useAppNavigate from "../components/hooks/useAppNavigate";
import ResetPassword from "../components/Modals/ForgotPassword/ResetPassword";
import FindAJob from "../components/Modals/find-a-job";
import OtpVerification from "../components/Modals/ForgotPassword/OtpVerification";
import { fetchCoachCategories } from "../redux/features/coach/actions/authAction";
import toast from "react-hot-toast";
import {
  setIsFindAJobModal,
  setRegisterStep,
} from "../redux/features/find-a-job/reducers/authReducer";
import {
  clearFreelancerFormData,
  clearPublicSessionsExcept,
  getActivePublicPanel,
  getHireTalentFormData,
  getProfile,
} from "../utils/pip";
import { normalizeHireTalentProfile } from "../utils/hireTalentProfile";
import HireTalent from "../components/Modals/hire-talent";
import {
  setIsHireTalentModal,
  setPage,
  setStartStep,
} from "../redux/features/hire-talent/reducers/authReducer";
import { enterPrisesPaths } from "../routes/enterprises";
import { fundingPaths } from "../routes/funding";

const MenuLayout = ({ children, user, isWorkShop }) => {
  const { goTo, goBack } = useAppNavigate();
  const { isFindAJobModal } = useSelector((state) => state.freelancer.auth);
  const { isHireTalentModal } = useSelector((state) => state.hireTalent.auth);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isSignUp, setIsSignUp] = useState(false);
  const [isLogin, setIsLogin] = useState(false);

  const [isForgot, setIsForgot] = useState(false);
  const [signStepup, setSignupStep] = useState("0");

  const [isOtp, setIsOtp] = useState(false);
  const [isSetPassword, setIsSetPassword] = useState(false);

  const [dbCode, setDbCode] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");

  const [isLoad, setIsLoad] = useState(false);
  const [isSidebarShow, setIsSidebarShow] = useState(false);

  const hireTalentToken = localStorage.getItem("hire-talent_token_nuvio");
  const freelancerToken = localStorage.getItem("freelancer_token_nuvio");
  const coachToken = localStorage.getItem("coach_token_nuvio");
  const activePublicPanel = getActivePublicPanel();

  const authPanel =
    activePublicPanel === "hire-talent" && hireTalentToken
      ? "hire-talent"
      : activePublicPanel === "freelancer" && freelancerToken
        ? "freelancer"
        : activePublicPanel === "coach" && coachToken
          ? "coach"
          : hireTalentToken
            ? "hire-talent"
            : freelancerToken
              ? "freelancer"
              : coachToken
                ? "coach"
                : "";

  const authProfile = authPanel ? getProfile(authPanel) : {};
  const savedHireTalentDraft = getHireTalentFormData();
  const normalizedHireTalentProfile =
    authPanel === "hire-talent"
      ? normalizeHireTalentProfile({
        ...(authProfile || {}),
        ...(authProfile?.hiretalent || {}),
      })
      : {};
  const authRole = String(
    authProfile?.role ||
    (authPanel === "coach"
      ? "COACH"
      : authPanel === "hire-talent"
        ? "HIRE_TALENT"
        : authPanel === "freelancer"
          ? "OPEN_TALENT"
          : "")
  ).toUpperCase();
  const isLoggedIn = !!authPanel;
  const hasProfileData =
    authProfile && Object.keys(authProfile || {}).length > 0;

  const composedName = [authProfile?.first_name, authProfile?.last_name]
    .filter(Boolean)
    .join(" ")
    .trim();

  const profileName =
    authPanel === "hire-talent"
      ? normalizedHireTalentProfile?.company_name ||
      authProfile?.hiretalent?.company_name ||
      authProfile?.company_name ||
      authProfile?.full_name ||
      composedName ||
      ""
      : authProfile?.full_name ||
      authProfile?.primary_contact_name ||
      authProfile?.company_name ||
      composedName ||
      "";

  const defaultProfileImage = "/assets/img/user_profile.png";
  const rawProfileImage = authProfile?.profile_image || authProfile?.image || "";
  const profileImage =
    rawProfileImage &&
      rawProfileImage !== "null" &&
      rawProfileImage !== "undefined"
      ? rawProfileImage
      : defaultProfileImage;

  const dashboardPath =
    authPanel === "coach" || authRole === "COACH"
      ? coachPaths?.CoachDashboard
      : authPanel === "hire-talent" || authRole === "HIRE_TALENT"
        ? hireTalentPaths?.Dashboard
        : authPanel === "freelancer" ||
          authRole === "OPEN_TALENT" ||
          authRole === "FREELANCER"
          ? findAJobPaths?.Dashboard
          : "";

  const freelancerTalentType = String(
    authProfile?.open_talent?.talent_type || authProfile?.talent_type || ""
  ).toUpperCase();
  const isFreelancerRole =
    authPanel === "freelancer" ||
    authRole === "OPEN_TALENT" ||
    authRole === "FREELANCER";
  const hasActiveFreelancerSubscription =
    authProfile?.active_subscription === true ||
    authProfile?.open_talent?.active_subscription === true;
  const needsFreelancerSubscription =
    isFreelancerRole &&
    freelancerTalentType === "FREELANCER" &&
    !hasActiveFreelancerSubscription;
  const freelancerSignupStep =
    Number(
      authProfile?.signup_step ||
      authProfile?.open_talent?.signup_step ||
      0
    ) || 0;
  const hireTalentSignupStep =
    Number(
      normalizedHireTalentProfile?.signup_step ||
      savedHireTalentDraft?.signup_step ||
      authProfile?.signup_step ||
      authProfile?.hiretalent?.signup_step ||
      0
    ) || 0;
  const isHireTalentOnboardingComplete = hireTalentSignupStep === 4;
  const needsFreelancerSignupStep =
    isFreelancerRole &&
    freelancerSignupStep > 0 &&
    freelancerSignupStep < 5;
  const isHireTalentRole =
    authPanel === "hire-talent" || authRole === "HIRE_TALENT";
  const hasHireTalentPrimaryContact = Boolean(
    normalizedHireTalentProfile?.primary_contact_name ||
    normalizedHireTalentProfile?.primary_contact_full_name ||
    normalizedHireTalentProfile?.primary_contact_email ||
    normalizedHireTalentProfile?.primary_contact_work_email ||
    savedHireTalentDraft?.primary_contact_name ||
    savedHireTalentDraft?.primary_contact_email
  );
  const hasHireTalentProjectDetails = Boolean(
    normalizedHireTalentProfile?.project_title ||
    normalizedHireTalentProfile?.role_in_project ||
    normalizedHireTalentProfile?.project_description ||
    savedHireTalentDraft?.project_title ||
    savedHireTalentDraft?.role_in_project ||
    savedHireTalentDraft?.project_description
  );
  const hasHireTalentWorkEnvironment = Boolean(
    normalizedHireTalentProfile?.preferred_timezone ||
    normalizedHireTalentProfile?.work_environment ||
    normalizedHireTalentProfile?.work_enviroment ||
    normalizedHireTalentProfile?.collaboration_type ||
    normalizedHireTalentProfile?.types_of_collaboration ||
    savedHireTalentDraft?.preferred_timezone ||
    savedHireTalentDraft?.collaboration_type
  );
  const inferredHireTalentStartStep = !hasHireTalentPrimaryContact
    ? 2
    : !hasHireTalentProjectDetails || !hasHireTalentWorkEnvironment
      ? 3
      : 0;
  const hireTalentStartStep =
    isHireTalentOnboardingComplete
      ? 0
      : hireTalentSignupStep === 1
      ? 2
      : hireTalentSignupStep === 2
        ? 3
        : hireTalentSignupStep > 0 && hireTalentSignupStep < 4
          ? Math.min(Math.max(hireTalentSignupStep, 1), 3)
          : inferredHireTalentStartStep;
  const needsHireTalentSignupStep =
    isHireTalentRole &&
    hireTalentStartStep > 0 &&
    hireTalentStartStep <= 3;

  const isProfileLoading = isLoggedIn && !hasProfileData;
  const canNavigateToDashboard =
    !!dashboardPath &&
    !isProfileLoading &&
    !needsFreelancerSubscription &&
    !needsFreelancerSignupStep &&
    !needsHireTalentSignupStep;
  const isProfileClickable =
    !isProfileLoading &&
    (!!dashboardPath ||
      needsFreelancerSubscription ||
      needsFreelancerSignupStep ||
      needsHireTalentSignupStep);
  const profileLabel = isProfileLoading
    ? "Loading..."

    : profileName || "My Profile";

  const handleProfileClick = () => {
    if (isProfileLoading) return;
    if (authPanel === "coach") {
      navigate(coachPaths?.CoachDashboard);
      return;
    }
    if (needsFreelancerSignupStep) {
      dispatch(setRegisterStep(`profileStep${freelancerSignupStep}`));
      dispatch(setIsFindAJobModal(true));
      return;
    }
    if (needsFreelancerSubscription) {
      dispatch(setRegisterStep("subscription"));
      dispatch(setIsFindAJobModal(true));
      return;
    }
    if (needsHireTalentSignupStep) {
      dispatch(setStartStep(hireTalentStartStep));
      dispatch(setIsHireTalentModal(true));
      return;
    }
    if (!canNavigateToDashboard) return;
    navigate(dashboardPath);
  };

  useEffect(() => {
    if (!authPanel) return;
    clearPublicSessionsExcept(authPanel);
  }, [authPanel]);

  useEffect(() => {
    if (isSignUp && signStepup == "2") {
      setIsLoad(true);
      dispatch(fetchCoachCategories()).then((res) => {
        setIsSignUp(true);
        setIsLoad(false);
        setSignupStep("2");
      });
    }
  }, [signStepup]);

  const handleFindJob = () => {
    dispatch(setIsFindAJobModal(true));
    setIsSignUp(false);
  };
  const handleHireTalent = () => {
    dispatch(setStartStep(1));
    dispatch(setIsHireTalentModal(true));
    setIsSignUp(false);
  };

  const handleContinueToNextStep = (selectForm) => {
    switch (selectForm) {
      case "coach":
        return setSignupStep("1");
      case "find-a-job":
        return handleFindJob();
      case "hire-telent":
        return handleHireTalent();

      default:
        return toast.error("Please select the user type");
    }
  };

  // if (isLoading) {
  //   return <Loader />;
  // }
  return (
    <>
      <header class="ct_header">
        <div class="ct_logo">
          <a onClick={() => navigate(enterPrisesPaths?.Enterprise)}>
            <img src="../assets/img/Nuvio_logo.png" alt="" />
          </a>
        </div>
        <div class={`ct_navbar ${isSidebarShow && "ct_show"}`}>
          <ul>
            <div class="ct_close_menu" onClick={() => setIsSidebarShow(false)}>
              <i class="fa-solid fa-xmark"></i>
            </div>
            <li className="ct_dropdown">
              <a>
                For Enterprises
                <i class="fa-solid fa-angle-down"></i>{" "}
              </a>
              <div class="ct_custom_dropdown">
                <ol>
                  <li onClick={() => navigate(coachPaths?.MatchTalent)}>
                    <a
                      className={
                        `${window.location?.pathname}` ==
                          coachPaths?.MatchTalent && "active"
                      }
                    >
                      Match Talent
                    </a>
                  </li>
                  <li onClick={() => navigate(coachPaths.PostJob)}>
                    <a
                      className={
                        `${window.location?.pathname}` == coachPaths.PostJob &&
                        "active"
                      }
                    >
                      Post Jobs
                    </a>
                  </li>
                  <li onClick={() => navigate(enterPrisesPaths.ExploreService)}>
                    <a
                      className={
                        `${window.location?.pathname}` ==
                          enterPrisesPaths?.ExploreService && "active"
                      }
                    >
                      Services
                    </a>
                  </li>
                </ol>
              </div>
            </li>
            <li class="ct_dropdown">
              <a>
                For Freelancers <i class="fa-solid fa-angle-down"></i>
              </a>
              <div class="ct_custom_dropdown">
                <ol>
                  <li onClick={() => navigate(coachPaths?.freelance)}>
                    <a
                      className={
                        `${window.location?.pathname}` ==
                          coachPaths?.freelance && "active"
                      }
                    >
                      Overview
                    </a>
                  </li>
                  <li onClick={() => navigate(coachPaths?.find_job)}>
                    <a
                      className={
                        `${window.location?.pathname}` ==
                          coachPaths?.find_job && "active"
                      }
                    >
                      Find Jobs
                    </a>
                  </li>
                  <li onClick={() => navigate(coachPaths.Learning)}>
                    <a
                      className={
                        `${window.location?.pathname}` ==
                          coachPaths?.Learning && "active"
                      }
                    >
                      Learning
                    </a>
                  </li>
                </ol>
              </div>
            </li>
            <li class="ct_dropdown">
              <a>
                CoachHUB <i class="fa-solid fa-angle-down"></i>
              </a>
              <div class="ct_custom_dropdown">
                <ol>
                  <li onClick={() => navigate(coachPaths?.WebinarLandingPage)}>
                    <a
                      className={
                        `${window.location?.pathname}` ==
                          coachPaths?.WebinarLandingPage && "active"
                      }
                    >
                      Overview
                    </a>
                  </li>
                  <li onClick={() => navigate(coachPaths?.FindCoach)}>
                    <a
                      className={
                        `${window.location?.pathname}` ==
                          coachPaths?.FindCoach && "active"
                      }
                    >
                      Find a Coach
                    </a>
                  </li>
                  <li onClick={() => navigate(coachPaths.BecomeCoach)}>
                    <a
                      className={
                        `${window.location?.pathname}` ==
                          coachPaths?.BecomeCoach && "active"
                      }
                    >
                      Become a Coach
                    </a>
                  </li>
                  <li className="ct_custom_dropdown_2">
                    <a>Events</a>
                    <ul>
                      <li onClick={() => navigate(coachPaths.BootCampList)}>
                        <a
                          className={
                            `${window.location?.pathname}` ==
                              coachPaths?.BootCampList && "active"
                          }
                        >
                          Bootcamp
                        </a>
                      </li>
                      <li
                        onClick={() =>
                          navigate(coachPaths?.WebinarData, {
                            state: { data: "webinar" },
                          })
                        }
                      >
                        <a
                          className={
                            `${window.location?.pathname}` ==
                              coachPaths?.WebinarData &&
                            isWorkShop == "webinar" &&
                            "active"
                          }
                        >
                          Webinar
                        </a>
                      </li>
                      <li
                        onClick={() =>
                          navigate(coachPaths?.WebinarData, {
                            state: { data: "workshop" },
                          })
                        }
                      >
                        <a
                          className={
                            `${window.location?.pathname}` ==
                              coachPaths?.WebinarData &&
                            isWorkShop == "workshop" &&
                            "active"
                          }
                        >
                          Workshop
                        </a>
                      </li>
                      <li
                        onClick={() =>
                          navigate(coachPaths?.WebinarData, {
                            state: { data: "nuterra" },
                          })
                        }
                      >
                        <a
                          className={
                            `${window.location?.pathname}` ==
                              coachPaths?.WebinarData &&
                            isWorkShop == "nuterra" &&
                            "active"
                          }
                        >
                          NuTerra
                        </a>
                      </li>
                    </ul>
                  </li>
                </ol>
              </div>
            </li>
            <li onClick={() => navigate(coachPaths.Community)}>
              <a
                className={
                  `${window.location?.pathname}` == coachPaths?.Community &&
                  "active"
                }
              >
                Community <i class="fa-solid fa-angle-down"></i>
              </a>

              <div class="ct_custom_dropdown">
                <ol>
                  <li onClick={() => navigate(coachPaths?.MatchTalent)}>
                    <a
                      className={
                        `${window.location?.pathname}` ==
                          coachPaths?.MatchTalent && "active"
                      }
                    >
                      Blog
                    </a>
                  </li>
                </ol>
              </div>
            </li>

            <li class="ct_dropdown">
              <a>
                Funding <i class="fa-solid fa-angle-down"></i>
              </a>
              <div class="ct_custom_dropdown">
                <ol>
                  <li onClick={() => navigate(fundingPaths?.Dashboard)}>
                    <a
                      className={
                        `${window.location?.pathname}` ==
                          fundingPaths?.Dashboard && "active"
                      }
                    >
                      Overview
                    </a>
                  </li>
                  <li onClick={() => navigate(fundingPaths?.ExploreProject)}>
                    <a
                      className={
                        `${window.location?.pathname}` ==
                          fundingPaths?.ExploreProject && "active"
                      }
                    >
                      Explore Project
                    </a>
                  </li>
                  <li
                    onClick={() => navigate(fundingPaths?.FundingSubmitProject)}
                  >
                    <a
                      className={
                        `${window.location?.pathname}` ==
                          fundingPaths?.FundingSubmitProject && "active"
                      }
                    >
                      Submit Project
                    </a>
                  </li>
                </ol>
              </div>
            </li>

            <li
              onClick={() =>
                navigate(coachPaths.AboutUs, { state: { data: "landing" } })
              }
            >
              <a
                className={
                  `${window.location?.pathname}` == coachPaths?.AboutUs &&
                  "active"
                }
              >
                About
              </a>
            </li>
            <li
              onClick={() =>
                navigate(coachPaths.ContactUs, { state: { data: "landing" } })
              }
            >
              <a
                className={
                  `${window.location?.pathname}` == coachPaths?.ContactUs &&
                  "active"
                }
              >
                Contact
              </a>
            </li>
            {/* <li>
              <a>Blog</a>
            </li> */}
          </ul>
        </div>
        <div class="d-flex align-items-center gap-4">
          {!isLoggedIn || isProfileLoading ? (
            <>
              <a
                class="ct_orange_link"
                onClick={() => {
                  setIsSignUp(true);
                  setSignupStep("0");
                }}
                // onClick={() => navigate(coachPaths.Signup)}
              >
                Sign Up
              </a>
              <a
                class="ct_orange_link"
                onClick={() => {
                  setIsLogin(true);
                  // setIsSignUp(false)
                  // setSignupStep('0');
                }}
              >
                Log in
              </a>
            </>
          ) : (
            <div
              class={`d-flex align-items-center gap-2 ct_cursor_pointer ${!isProfileClickable ? "ct_pointer_events_none ct_text_clr_acacac" : ""}`}
              onClick={handleProfileClick}
            >
              <img
                class="ct_img_30"
                src={profileImage}
                alt=""
                onError={(event) => {
                  event.currentTarget.onerror = null;
                  event.currentTarget.src = defaultProfileImage;
                }}
              />
              <span class="text-dark">{profileLabel}</span>
            </div>
          )}
          <a class="text-dark ">
            UK <img src="assets/img/flag.png" alt="" />{" "}
          </a>
          <div class="ct_menu_bar" onClick={() => setIsSidebarShow(true)}>
            <i class="fa-solid fa-bars-staggered"></i>
          </div>
        </div>
      </header>

      {/* {children} */}
      {typeof children === "function"
        ? children({
            openSignUp: () => {
              setIsSignUp(true);
              setSignupStep("0");
            },
            openLogin: () => {
              setIsLogin(true);
            },
          })
        : children}

      <footer class="ct_px_40 py-5 mt-0">
        <div class="ct_footer_logo">
          <a onClick={() => navigate(enterPrisesPaths?.Enterprise)}>
            <img src="/assets/img/Nuvio_logo.png" alt="" />
          </a>
        </div>
        <div class="row pt-4">
          <div class="col-xxl-3 col-xl-2 col-md-6 mb-4">
            <div class="ct_footer_links">
              <h4 class="ct_fs_20 ct_darkblue_text mb-3">Navigation</h4>
              <ul>
                <li>
                  <a onClick={(e) => goTo(e)}>For Enterprises</a>
                </li>
                <li>
                  <a onClick={(e) => goTo(e)}>For Freelancers</a>
                </li>
                <li>
                  <a onClick={(e) => goTo(e)}>CoachHUB</a>
                </li>
                <li>
                  <a onClick={(e) => goTo(e)}>Funding</a>
                </li>
                <li>
                  <a
                    onClick={() =>
                      navigate(coachPaths.AboutUs, {
                        state: { data: "landing" },
                      })
                    }
                  >
                    About Us
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xxl-3 col-xl-2 col-md-6 mb-4">
            <div class="ct_footer_links">
              <h4 class="ct_fs_20 ct_darkblue_text mb-3">Resources</h4>
              <ul>
                <li>
                  <a onClick={(e) => goTo(e)}>Blog</a>
                </li>
                <li>
                  <a onClick={(e) => goTo(e)}>Newsletter</a>
                </li>
                <li>
                  <a onClick={(e) => goTo(e)}>Tutorials</a>
                </li>
                <li>
                  <a onClick={(e) => goTo(e)}>Support</a>
                </li>
                <li>
                  <a onClick={(e) => goTo(e)}>Help Centre</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xxl-2 col-xl-3 col-md-6 mb-4">
            <div class="ct_footer_links">
              <h4 class="ct_fs_20 ct_darkblue_text mb-3">Get in Touch</h4>
              <ul>
                <li>
                  <a
                    href="mailto:hello@nu-vio.com"
                    className="d-flex align-items-center gap-2"
                  >
                    <i class="fa-solid fa-envelope me-1 ct_yellow_text"></i>
                    hello@nu-vio.com
                  </a>
                </li>
                <li>
                  <a
                    href="tel:+33 6 66 92 57 30"
                    className="d-flex align-items-center gap-2"
                  >
                    <i class="fa-solid fa-phone me-1 ct_yellow_text"></i> +33 6
                    66 92 57 30
                  </a>
                </li>
                <li>
                  <a className="d-flex align-items-center gap-2">
                    <i class="fa-solid fa-location-dot ct_yellow_text me-1"></i>{" "}
                    Office 36, 1 Exchange Building (TBE), Cybercity, Ebene
                    Mauritius
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xxl-4 col-xl-5 col-md-6 mb-4">
            <div class="ct_newsletter_bg">
              <p>Ready to keep up with what’s next?</p>
              <div class="d-flex align-items-center gap-2 justify-content-between ct_flex_col_991">
                <div class="form-group ct_flex_1 ct_w_100_991">
                  <input
                    type="email"
                    class="form-control ct_input ct_border_radius_100"
                    placeholder="Enter your email address"
                  />
                </div>
                <div class="ct_w_100_991">
                  <button class="ct_yellow_btn ct_darkblue_btn ct_border_radius_100 ct_h_48 ct_w_100_991">
                    Subscribe now
                  </button>
                </div>
              </div>
            </div>
            <div class="pt-4">
              <h5 class="ct_fs_18 mb-3">Follow Us</h5>
              <div class="d-flex align-items-center gap-2">
                <a style={{ color: "#0076B2" }}>
                  <i class="fa-brands fa-linkedin"></i>
                </a>
                <a style={{ color: "#3D5A98" }}>
                  <i class="fa-brands fa-square-facebook"></i>
                </a>
                <a style={{ color: "#FF0000" }}>
                  <i class="fa-brands fa-youtube"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="row pt-4 ct_border_top_1">
          <div class="col-md-12">
            <p class="mb-0 text-center">
              Copyright @ 2025 NUVIO All Rights Reserved
            </p>
          </div>
        </div>
      </footer>
      {isSignUp && signStepup == "0" && (
        <CoachSignUp
          handleContinueToNextStep={handleContinueToNextStep}
          backToLogin={() => {
            setIsLogin(true);
            setIsSetPassword(false);
            setIsSignUp(false);
            setSignupStep("");
            setIsForgot(false);
            setIsOtp(false);
          }}
          onClose={() => {
            setIsSignUp(false);
            setSignupStep("0");
            setIsForgot(false);
            setIsSetPassword(false);
            setIsOtp(false);
            setIsLogin(false);
          }}
          setSignupStep={() => setSignupStep("1")}
        />
      )}
      {isSignUp && signStepup == "1" && (
        <CoachSignUpStep1Modal
          backToLogin={() => {
            setIsLogin(true);
            setIsSignUp(false);
            setIsSetPassword(false);
            setSignupStep("");
            setIsForgot(false);
            setIsOtp(false);
          }}
          onClose={() => {
            setIsSignUp(false);
            setIsForgot(false);
            setIsOtp(false);
            setIsLogin(false);
            setSignupStep("0");
            setIsSetPassword(false);
          }}
          setSignupStep={() => setSignupStep("2")}
          stepBack={() => setSignupStep("0")}
        />
      )}
      {isSignUp && signStepup == "2" && (
        <CoachSignUpStep2Modal
          isLoad={isLoad}
          backToLogin={() => {
            setIsLogin(true);
            setIsSignUp(false);
            setSignupStep("");
            setIsForgot(false);
            setIsSetPassword(false);
            setIsOtp(false);
          }}
          onClose={() => {
            setIsSignUp(false);
            setSignupStep("0");
            setIsForgot(false);
            setIsOtp(false);
            setIsSetPassword(false);
            setIsLogin(false);
          }}
          setSignupStep={() => setSignupStep("3")}
          stepBack={() => setSignupStep("1")}
        />
      )}
      {isSignUp && signStepup == "3" && (
        <CoachSignUpStep3Modal
          onClose={() => {
            setIsSignUp(false);
            setSignupStep("0");
            setIsForgot(false);
            setIsOtp(false);
            setIsLogin(false);
            setIsSetPassword(false);
          }}
          setSignupStep={() => setSignupStep("4")}
          stepBack={() => setSignupStep("2")}
        />
      )}
      {isLogin && (
        <CoachLogin
          onSignUp={() => {
            setIsSignUp(true);
            setIsLogin(false);
            setSignupStep("0");
            setIsForgot(false);
            setIsOtp(false);
            setIsSetPassword(false);
          }}
          onClose={() => {
            setIsForgot(false);
            setIsOtp(false);
            setIsSignUp(false);
            setIsLogin(false);
            setIsSetPassword(false);
          }}
          onForgot={() => {
            setIsForgot(true);
            setIsLogin(false);
            setIsOtp(false);
            setIsSignUp(false);
            setIsSetPassword(false);
          }}
        />
      )}
      {isForgot && (
        <CoachForgotPassword
          isLoad={isLoad}
          setIsLoad={setIsLoad}
          onForgot={() => {
            setIsForgot(true);
            setIsLogin(false);
            setIsOtp(false);
            setIsSignUp(false);
            setIsSetPassword(false);
          }}
          backToLogin={() => {
            setIsLogin(true);
            setIsForgot(false);
            setIsOtp(false);
            setIsSignUp(false);
            setIsSetPassword(false);
          }}
          onClose={() => {
            setIsForgot(false);
            setIsOtp(false);
            setIsSignUp(false);
            setIsLogin(false);
            setIsSetPassword(false);
          }}
          otpScreen={() => {
            setIsOtp(true);
            setIsLogin(false);
            setIsForgot(false);
            setIsSignUp(false);
            setIsSetPassword(false);
          }}
          setData={(val, data, role) => {
            setDbCode(val);
            setEmail(data);
            setRole(role);
          }}
        />
      )}
      {isOtp && (
        <OtpVerification
          role={role}
          isLoad={isLoad}
          setIsLoad={setIsLoad}
          otpScreen={() => {
            setIsOtp(true);
            setIsLogin(false);
            setIsForgot(false);
            setIsSignUp(false);
            setIsSetPassword(false);
          }}
          onClose={() => {
            setIsOtp(false);
            setIsForgot(false);
            setIsSignUp(false);
            setIsLogin(false);
            setIsSetPassword(false);
            setDbCode("");
            setEmail("");
          }}
          backToLogin={() => {
            setIsLogin(true);
            setIsForgot(false);
            setIsOtp(false);
            setIsSignUp(false);
            setIsSetPassword(false);
            setDbCode("");
            setEmail("");
          }}
          email={email}
          dbCode={dbCode}
          nextStep={() => setIsSetPassword(true)}
        />
      )}
      {isSetPassword && (
        <ResetPassword
          onClose={() => {
            setIsOtp(false);
            setIsForgot(false);
            setIsSignUp(false);
            setIsLogin(false);
            setIsSetPassword(false);
            setDbCode("");
            setEmail("");
          }}
          backToLogin={() => {
            setIsLogin(true);
            setIsForgot(false);
            setIsOtp(false);
            setIsSignUp(false);
            setIsSetPassword(false);
            setDbCode("");
            setEmail("");
          }}
          forgot_code={dbCode}
          handleFinalSubmit={() => {
            setDbCode("");
            setEmail("");
          }}
        />
      )}
      {/* find-a-job */}

      {isFindAJobModal && (
        <FindAJob
          onClose={() => {
            clearFreelancerFormData();
            localStorage.removeItem("freelancer_profile_nuvio");
            setIsSignUp(false);
            dispatch(setIsFindAJobModal(false));
            dispatch(setRegisterStep(1));
            setSignupStep("0");
          }}
          stepBack={() => {
            clearFreelancerFormData();
            localStorage.removeItem("freelancer_profile_nuvio");
            dispatch(setIsFindAJobModal(false));
            setIsSignUp(true);
            setSignupStep("0");
          }}
          backToLogin={() => {
            dispatch(setIsFindAJobModal(false));
            setIsLogin(true);
          }}
        />
      )}
      {isHireTalentModal && (
        <HireTalent
          onClose={() => {
            setIsSignUp(false);
            dispatch(setPage("signup"));
            dispatch(setStartStep(1));
            dispatch(setIsHireTalentModal(false));
            setSignupStep("0");
          }}
          backToLogin={() => {
            dispatch(setIsHireTalentModal(false));
            dispatch(setPage("signup"));
            setIsLogin(true);
          }}
        />
      )}
    </>
  );
};

export default MenuLayout;
